<template>
  <div class="bp-switch">
    <b-form-checkbox
      v-model="innerValue"
      switch
      @change="v => $emit('change', v)"
    >
      <div class="d-flex">
        <span
          :class="innerValue ? 'text-primary-500' : 'text-neutral-600'"
          class="ml-3"
        >
          {{ label }}
          <span v-if="required" class="text-negative-700">*</span>
        </span>
        <bp-tooltip v-if="warning" :text="warning">
          <i class="fa fa-circle-exclamation text-negative-500 ml-3 fs-14" />
        </bp-tooltip>
      </div>
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    label: {
      type: String
    },
    required: {
      type: Boolean
    },
    warning: {
      type: String
    },
    id: {
      type: String,
      default: "bp-switch"
    }
  },
  data() {
    return {
      innerValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
    innerValue(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>
<style lang="scss" scoped>
.bp-switch {
  min-height: 32px;
  display: flex;
  align-items: center;
  ::v-deep {
    .custom-switch {
      display: flex;
      padding-left: 32px;

      .custom-control-label {
        &::before {
          box-shadow: none;
          left: -32px;
          width: 32px;
          height: 18px;
          border-radius: 9px;
          border-color: #929292;
          background-color: transparent;
        }
        &::after {
          top: 6px;
          left: -30px;
          width: 14px;
          height: 14px;
          border-radius: 100%;
          background-color: #929292;
        }
      }

      &:has(.custom-control-input:checked) {
        .custom-control-label {
          &::before {
            border-color: transparent;
            background-color: rgba(131, 35, 255, 1);
          }
          &::after {
            transform: translateX(14px);
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
